import { Column, ColumnType } from '@scale/compass-shared/types';
import type { WorkerTeamAdapterContext } from '@scale/genai-compass-shared/cards/worker_team_adapter';
import {
  WorkerTeamAdapterCardShared,
  WorkerTeamAdapterSchemaType,
  WORKER_TEAM_ADAPTER,
} from '@scale/genai-compass-shared/cards/worker_team_adapter';
import { CompassCardUI } from '@scale/compass-ui/types';
import WorkerTeamAdapterCardComponent from 'react-scale/corp/views/DataCompassCardsV2/adapter/WorkerTeamAdapterCard/WorkerTeamAdapterCardComponent';
import { faUsersBetweenLines } from '@fortawesome/pro-solid-svg-icons';

/** Input columns for Worker Team Adapter filtering. */
export const WORKER_TEAM_ADAPTER_INPUT_COLUMNS: Record<string, Column> = {
  workerTeamId: {
    id: 'id',
    header: 'Worker Team ID',
    type: ColumnType.TEXT,
  },
  parentWorkerTeamId: {
    id: 'parentTeamId',
    header: 'Parent Worker Team ID',
    type: ColumnType.TEXT,
  },
  name: {
    id: 'name',
    header: 'Name',
    type: ColumnType.TEXT,
  },
};

const defaultContext: WorkerTeamAdapterContext = {
  cardType: WORKER_TEAM_ADAPTER,
  filter: {
    operator: 'and',
    filtersOrFilterGroups: [
      {
        column: WORKER_TEAM_ADAPTER_INPUT_COLUMNS.name,
        condition: 'is_not_empty',
        term: '',
      },
    ],
  },
};

export const WorkerTeamAdapterCardInfo: CompassCardUI<WorkerTeamAdapterSchemaType> = {
  ...WorkerTeamAdapterCardShared,
  title: 'Get Worker Teams',
  icon: 'users',
  toolTip: 'Fetch worker teams.',
  defaultContext,
  legacyComponent: WorkerTeamAdapterCardComponent,
  button: {
    icon: faUsersBetweenLines,
  },
};
